import CONFIG from '../config'

const webhookServer = CONFIG.REACT_APP_WEBHOOK_SERVER

export const fetchApi = async (
  path = '/',
  variables: any = {},
  options: RequestInit = {}
) => {
  const authenticateUrl = new URL(webhookServer + path)
  Object.keys(variables).forEach((key: string) => {
    const value = variables[key]
    authenticateUrl.searchParams.append(key, value)
  })
  const res = await fetch(authenticateUrl.href, options)
  if (res && res?.status >= 400) {
    console.error(`Error on path ${path} occured`)
    console.error('server error', res)
    throw new Error(res.status.toString())
  }
  return res && (res.type === 'opaque' ? res : res.json())
}

export const WEBHOOK_API_PATHS = {
  authenticate: '/api/authenticate',
  verifyAuth: '/api/verify-auth',
  verifyPassword: '/api/verify-pass',
  newPassword: '/api/new-password',
  passwordForget: '/api/password-forget',
  passwordTokenVerify: '/api/password-token-verify',
  newPasswordWithAuth: '/api/new-password-with-auth',
  createClient: '/api/client-register'
}
